import styled, { css } from 'styled-components';
import { HeadingStyle } from 'components/heading';
import { TextStyle } from 'components/text';
import { FontWeight, device } from 'commons';

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (min-width: ${device.desktopSmall}px) {
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

export const TitleWrapper = styled.div`
  align-self: center;
  display: flex;
  flex-direction: column;
  width: fit-content;
  padding-bottom: 5px;
  border-bottom: 1px solid ${({ theme }) => theme.neutral_500};
  margin-bottom: 20px;
`;

export const TextContainer = styled.div<{ $baseline?: boolean }>`
  display: flex;
  flex: 1;
  align-items: flex-start;
  color: ${({ theme }) => theme.neutral_500};
  gap: 5px;
  overflow: hidden;

  ${HeadingStyle} {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  ${({ $baseline }) =>
    $baseline &&
    css`
      align-items: baseline;
    `}
`;

export const TextWrapper = styled.div<{ $spaced?: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-direction: row-reverse;

  strong {
    overflow: visible;
    font-weight: ${FontWeight.bold};
  }

  ${({ $spaced }) => $spaced && 'margin: 20px 0;'}
`;

export const CopyWrapper = styled.div`
  &:hover {
    & + ${TextContainer} {
      background-color: ${({ theme }) => theme.neutral_200};
      box-shadow: 0 0 0 4px ${({ theme }) => theme.neutral_200};
      border-radius: 2px;
    }
  }
`;

export const Icon = styled.div<{ $large?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;

  svg {
    width: 100%;
    height: 100%;
  }

  ${({ $large }) =>
    $large &&
    css`
      width: 20px;
      height: 20px;
    `}
`;

export const HorizontalLine = styled.div<{ $dashed?: boolean }>`
  border-bottom: 1px solid ${({ theme }) => theme.neutral_500};
  flex: 1;

  ${({ $dashed }) =>
    $dashed &&
    css`
      border-style: dashed;
    `}
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Section = styled.div`
  min-width: 280px;
  flex: 1;
`;

export const CustomerInfo = styled.div`
  padding-bottom: 30px;
`;

export const DeliveryAddressInfo = styled.div`
  padding-bottom: 30px;
`;

export const PaymentInfo = styled.div`
  background-color: ${({ theme }) => theme.yellow};
  padding: 35px 30px 60px;

  ${TextStyle} {
    font-family: 'Courier New', Courier, monospace;
  }
`;

export const SawToothBorder = styled.div`
  display: flex;
  flex: 1;
  height: 20px;
  background-image:
    linear-gradient(45deg, transparent 60%, ${({ theme }) => theme.yellow} 50%),
    linear-gradient(-45deg, transparent 60%, ${({ theme }) => theme.yellow} 50%);
  background-size:
    20px 20px,
    20px 20px;
  background-repeat: repeat-x;
`;
